import { useEffect } from 'react';

const ADS_ID = 'AW-16949700128';
const configuredIds = new Set();

export function initializeGoogleTag(measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID) {
  // Keep previews and the static prerenderer out of production reports.
  if (!['asmrchurch.com', 'www.asmrchurch.com'].includes(window.location.hostname) ||
      /ReactSnap/i.test(navigator.userAgent)) return;

  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
  }

  const ids = [ADS_ID];
  if (/^G-[A-Z0-9]+$/.test(measurementId || '')) ids.push(measurementId);
  ids.forEach((id) => {
    if (configuredIds.has(id)) return;
    // GA4 enhanced measurement owns initial and History API page views.
    window.gtag('config', id);
    configuredIds.add(id);
  });

  if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
    document.head.appendChild(script);
  }
}

export default function GoogleTag() {
  useEffect(() => { initializeGoogleTag(); }, []);
  return null;
}
